import React, { useEffect, useRef, useState } from 'react';
// utils
import "swiper/css";
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isColorLight } from '../../../utils/FunctionsGlobals';
import CardDepoimento2 from '../../cards/depoimentos/Depoimentos2';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import styles from './DepoimentosCard2.module.css';

// interfaces
interface IDepoimentCard2 {
    slides: Array<any>;
    title: string;
    site: any;
    pagina?: any;
}

// ajuste esses valores conforme o seu card e gap do swiper
const MIN_CARD_WIDTH = 320; // ou 320, depende do seu design
const GAP = 20; // mesmo valor do spaceBetween

const DepoimentoCard2: React.FC<IDepoimentCard2> = ({ slides, title, site, pagina }) => {
    const cor_texto = isColorLight(site?.cor15) ? site?.cor11 : site?.cor13; 
    const containerRef = useRef<HTMLDivElement | null>(null);
    const cor_font_botoes = isColorLight(site?.cor2) ? site?.cor11 : site?.cor13;
    const [viewCount, setViewCount] = useState(1);
      const stylo: React.CSSProperties = {
        '--swiper-navigation-color': cor_font_botoes,
        '--swiper-pagination-color': cor_font_botoes,
        '--swiper-pagination-bullet-inactive-color': cor_font_botoes,
        '--swiper-pagination-bullet-inactive-opacity': '0.5',
        '--swiper-pagination-bullet-size': '15px',
        'padding': '10px 10px 60px 10px'
    } as React.CSSProperties;

    useEffect(() => {
        if (!containerRef.current) return;
        const calc = () => {
            const width = containerRef.current!.clientWidth;
            const cardsFit = Math.max(
                1,
                Math.floor((width + GAP) / (MIN_CARD_WIDTH + GAP))
            );
            setViewCount(cardsFit);
        };
        calc();
        const ro = new (window as any).ResizeObserver(calc);
        ro.observe(containerRef.current);
        return () => ro.disconnect();
    }, []);

    const handleWhatsAppClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        trackLead(site, null);
        setTimeout(() => {
            const whatsappUrl = site?.id == "1937" 
                ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`
                : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
            window.open(whatsappUrl, "_blank");
        }, 300);
    };

    return (
        <div
            ref={containerRef}
            className={styles.container}
            style={{background: site?.cor15}}
        >
            <div className={styles.header}>
                <h2 className={styles.title} style={{color: cor_texto}}>DEPOIMENTOS</h2>
                <h3 className={styles.subtitle} style={{color: site?.cor2}}>O que os clientes dizem</h3>
                <p className={styles.description} style={{color: cor_texto}}>
                    Atribuímos um grande valor a relacionamentos sólidos e vimos os Benefícios que eles trazem
                    para o nosso negócio. O Feedback do cliente é vital para nos ajudar a acertar.
                </p>
            </div>
            <div className={styles.testimonialsContainer}>
                <Swiper
                    modules={[Pagination,Autoplay]}
                    style={stylo}
                    className={styles.swiper}
                    slidesPerView={viewCount}
                    spaceBetween={GAP}
                    pagination={{ clickable: true, dynamicBullets: true }} // ATIVAR
                    autoplay={{
                        delay: 8500,
                        disableOnInteraction: true,
                    }}
                    loop={slides.length > viewCount}
                >
                    {slides?.map((slide, idx) => (
                        <SwiperSlide
                            key={slide.id || idx}
                            className={styles.slide}
                            style={{ width: `calc(100% / ${viewCount})` }}
                        >
                            <CardDepoimento2
                                i={idx}
                                slide={slide}
                                site={site}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {site?.Dados?.tel1 && (
                <div className={styles.ctaAll}>
                    <div className={styles.ctaSection}>
                        <div className={styles.ctaContent}>
                            <span className={styles.ctaText}>
                                <strong>Achar um imóvel</strong> pode ser mais fácil...
                            </span>
                            <span className={styles.ctaSubtext}>
                                Contrate gratuitamente nossa assessoria vip de busca de imóveis.
                            </span>
                        </div>
                        <button 
                            className={styles.ctaButton}
                            onClick={handleWhatsAppClick}
                            style={{ backgroundColor: site?.cor2 || '#B8860B',color: cor_font_botoes }}
                        >
                            Sim! Acelerar Busca
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DepoimentoCard2;
function toShortHex(cor1: any) {
    throw new Error('Function not implemented.');
}

